<template>
  <div class="choose-org-btn">
    <el-input
      v-model="inputValue"
      @click="visible = true"
      clearable @clear="handleClear"
      @change="handleValueChange"
      :placeholder="$t('common.pleaseSelect')"
      v-bind="$attrs"
    />
    <h-dialog v-model="visible" :title="$t('commonComponents.selectOrg')" width="600px" @on-ok="handleSubmit">
      <div class="content">
        <el-radio-group v-model="selectRow">
          <h-table
            ref="tableRef"
            vuexNamespace="choose-org-btn"
            :http="getTableData"
            :columns="columns"
            :query-form="queryForm"
            :show-reset="false"
            :show-query="false"
            pagPayout="prev, pager, next"
            pagSize="small"
            row-key="id"
            style="height: 500px;"
            @result="getTableResult"
          >
            <template #checked="{ row }">
              <el-radio :value="row"></el-radio>
            </template>
          </h-table>
        </el-radio-group>
      </div>
    </h-dialog>
  </div>
</template>

<script setup>

import { ref, watch } from 'vue'
import { getOrgAll } from '@/api/order-manager/sale-order.js'
import { $t } from '@/i18n';

const { modelValue } = defineProps(['modelValue'])
const $emit = defineEmits(['update:modelValue', 'change'])
const inputValue = ref('')
const visible = ref(false)

const selectRow = ref()
const tableRef = ref()
const tableData = ref([])
const getTableData = (params) => {
  return getOrgAll(params)
}
const getTableResult = (res) => {
  tableData.value = res.data.rows
}


watch(() => modelValue, (val) => {
  if (val) {
    const row = tableData.value.find(item => item.id === val)
    if (row) {
      selectRow.value = row
      inputValue.value = row.name
    }
  } else {
    selectRow.value = void 0
    inputValue.value = ''
  }
})

const handleSubmit = () => {
  $emit('update:modelValue', selectRow.value.id)
  $emit('change')
  inputValue.value = selectRow.value.name
  visible.value = false
}


const handleClear = () => {
  $emit('update:modelValue', '')
  inputValue.value = void 0
}

const handleValueChange = (value) => {
  $emit('update:modelValue', value)
  $emit('change')
}

/* 列名 */
const columns = [
  {
    prop: 'checked',
    minWidth: 50,
    label: '',
    scopedSlots: 'checked'
  },
  {
    prop: 'name',
    label: $t('userModules.org.orgName'),
    minWidth: 300
  }
]

/* 查询 form */
const queryForm = ref({
  formItems: [
    {
      key: 'name',
      type: 'input',
      placeholder: $t('commonComponents.pleSelectOrh')
    }
  ]
})
</script>

<style scoped lang="scss">
.content {
  height: 650px;

  .el-radio-group {
    display: block;
  }
}

:deep(.el-row) {
  .form-row {
    min-width: 100%;
    padding-right: 10px !important;
  }
}
</style>